import { render, staticRenderFns } from "./SdkFrameShell.vue?vue&type=template&id=23a3ddb2"
import script from "./SdkFrameShell.vue?vue&type=script&lang=js"
export * from "./SdkFrameShell.vue?vue&type=script&lang=js"
import style0 from "./SdkFrameShell.vue?vue&type=style&index=0&id=23a3ddb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports